import LegalLayout from './LegalLayout';

export default function CookiePage() {
  return (
    <LegalLayout title="Cookie Policy" lastUpdate="26 Aprile 2026">
      <h2 className="font-outfit text-xl font-bold text-slate-800 mt-0">1. Cosa sono i cookie</h2>
      <p className="text-slate-700">
        I cookie sono piccoli file di testo che i siti web inviano al browser dell'utente e vengono
        memorizzati per essere ritrasmessi al sito stesso nelle visite successive. Sono utilizzati per
        diverse finalità, tra cui il funzionamento del sito, il miglioramento dell'esperienza utente
        e la generazione di statistiche.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">2. Cookie utilizzati da Kyloo</h2>
      <p className="text-slate-700">
        Kyloo utilizza esclusivamente <strong>cookie tecnici e di sessione</strong>, necessari per il
        funzionamento del servizio. Non utilizziamo cookie di profilazione né cookie pubblicitari di terze parti.
      </p>

      <h3 className="font-outfit text-lg font-semibold text-slate-800">2.1 Cookie tecnici (sempre attivi)</h3>
      <table className="w-full text-sm text-slate-700 border-collapse my-4">
        <thead>
          <tr className="bg-slate-100">
            <th className="border border-slate-200 p-2 text-left">Nome</th>
            <th className="border border-slate-200 p-2 text-left">Finalità</th>
            <th className="border border-slate-200 p-2 text-left">Durata</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-slate-200 p-2"><code>session_token</code></td>
            <td className="border border-slate-200 p-2">Mantenere l'utente autenticato (httpOnly, secure)</td>
            <td className="border border-slate-200 p-2">7 giorni</td>
          </tr>
          <tr>
            <td className="border border-slate-200 p-2"><code>kyloo_login_intent</code></td>
            <td className="border border-slate-200 p-2">Routing post-login (utente vs negoziante) - sessionStorage</td>
            <td className="border border-slate-200 p-2">Sessione</td>
          </tr>
          <tr>
            <td className="border border-slate-200 p-2"><code>kyloo_guest_mode</code></td>
            <td className="border border-slate-200 p-2">Modalità ospite - sessionStorage</td>
            <td className="border border-slate-200 p-2">Sessione</td>
          </tr>
        </tbody>
      </table>

      <h3 className="font-outfit text-lg font-semibold text-slate-800">2.2 Cookie di terze parti</h3>
      <p className="text-slate-700">
        Quando l'utente sceglie di accedere tramite Google OAuth, possono essere impostati cookie da
        Google secondo la loro privacy policy. Vedi <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">policy cookie di Google</a>.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">3. Gestione dei cookie</h2>
      <p className="text-slate-700">
        Poiché Kyloo utilizza solo cookie tecnici strettamente necessari al funzionamento del servizio
        (esenti dall'obbligo di consenso preventivo ai sensi dell'art. 122 del Codice Privacy e delle
        Linee Guida del Garante del 10/06/2021), non viene mostrato alcun banner cookie.
      </p>
      <p className="text-slate-700">
        L'utente può comunque gestire o disabilitare i cookie direttamente dal proprio browser:
      </p>
      <ul className="text-slate-700">
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Eliminare%20i%20cookie" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Microsoft Edge</a></li>
      </ul>
      <p className="text-slate-700 italic">
        Disabilitando i cookie tecnici, alcune funzionalità del Servizio potrebbero non essere disponibili
        (es. login, gestione preferiti).
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">4. Modifiche alla Cookie Policy</h2>
      <p className="text-slate-700">
        La presente Cookie Policy potrà essere aggiornata. Le modifiche saranno pubblicate in questa pagina
        con indicazione della data di ultimo aggiornamento.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">5. Contatti</h2>
      <p className="text-slate-700">
        Per domande sull'utilizzo dei cookie, scrivi a <strong>kyloo.app@libero.it</strong>.
      </p>
    </LegalLayout>
  );
}
